import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./EnumResources.da.resx"
import { R as _en } from "./EnumResources.en.resx"
import { R as _nb } from "./EnumResources.nb.resx"

type Translations = {
	"Name1": string,
	"Bitmap1": string,
	"Icon1": string,
	"CaregiverRoleEnum_AllergyDoctor": string,
	"CaregiverRoleEnum_Dentist": string,
	"CaregiverRoleEnum_Dermatologist": string,
	"CaregiverRoleEnum_Doctor": string,
	"CaregiverRoleEnum_Midwife": string,
	"CaregiverRoleEnum_Nurse": string,
	"CaregiverRoleEnum_Physiotherapist": string,
	"CaregiverRoleEnum_Psychologist": string,
	"CaregiverRoleEnum_Rheumatologist": string,
	"CaregiverRoleEnum_SundVaegtDoctor": string,
	"CaregiverRoleEnum_SundVaegtNurse": string,
	"CaregiverRoleEnum_Dietitian": string,
	"CaregiverRoleEnum_AcneDermatologist": string,
	"CaregiverRoleEnum_Veterinarian": string,
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": string,
	"CaregiverRoleEnum_Dentist_Indefinite": string,
	"CaregiverRoleEnum_Dermatologist_Indefinite": string,
	"CaregiverRoleEnum_Doctor_Indefinite": string,
	"CaregiverRoleEnum_Midwife_Indefinite": string,
	"CaregiverRoleEnum_Nurse_Indefinite": string,
	"CaregiverRoleEnum_Physiotherapist_Indefinite": string,
	"CaregiverRoleEnum_Psychologist_Indefinite": string,
	"CaregiverRoleEnum_Rheumatologist_Indefinite": string,
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": string,
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": string,
	"CaregiverRoleEnum_Dietitian_Indefinite": string,
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": string,
	"CaregiverRoleEnum_Veterinarian_Indefinite": string,
	"CaregiverSpecialization_ClinicalPsychologist": string,
	"CaregiverSpecialization_FamilyTherapy": string,
	"CaregiverSpecialization_SundVaegt": string,
	"CaregiverSpecialization_Pediatric": string,
	"ConsultationPaymentProviderEnum_ApplePay": string,
	"ConsultationPaymentProviderEnum_Company": string,
	"ConsultationPaymentProviderEnum_Coupon": string,
	"ConsultationPaymentProviderEnum_DIBS": string,
	"ConsultationPaymentProviderEnum_ePay": string,
	"ConsultationPaymentProviderEnum_GoogleWallet": string,
	"ConsultationPaymentProviderEnum_GracePeriod": string,
	"ConsultationPaymentProviderEnum_ReepayCheckout": string,
	"ConsultationPaymentProviderEnum_Repay": string,
	"ConsultationPaymentProviderEnum_Subscription": string,
	"ConsultationPaymentProviderEnum_PriceOverride": string,
	"ConsultationCategoryFilterEnum_Video": string,
	"ConsultationCategoryFilterEnum_Text": string,
	"ConsultationTypeEnum_AllergyCheckVideo": string,
	"ConsultationTypeEnum_DentistMessage": string,
	"ConsultationTypeEnum_DentistVideo": string,
	"ConsultationTypeEnum_DermatologistMessage": string,
	"ConsultationTypeEnum_DermatologistVideo": string,
	"ConsultationTypeEnum_Message": string,
	"ConsultationTypeEnum_MidwifeMessage": string,
	"ConsultationTypeEnum_MidwifeVideo": string,
	"ConsultationTypeEnum_NurseMessage": string,
	"ConsultationTypeEnum_NurseVideo": string,
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": string,
	"ConsultationTypeEnum_PhysiotherapistMessage": string,
	"ConsultationTypeEnum_Prescription": string,
	"ConsultationTypeEnum_PsychologistVideo": string,
	"ConsultationTypeEnum_PsychologistCrisisVideo": string,
	"ConsultationTypeEnum_PsychologistFamilyTherapyVideo": string,
	"ConsultationTypeEnum_RheumatologistVideo": string,
	"ConsultationTypeEnum_SundVaegtStartupMessage": string,
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": string,
	"ConsultationTypeEnum_Video": string,
	"ConsultationTypeEnum_DietitianStartupVideo": string,
	"PlanInterval_Day": string,
	"PlanInterval_Month": string,
	"PlanInterval_Week": string,
	"PlanInterval_Year": string,
	"ServiceTypeEnum_AllergyCheck": string,
	"ServiceTypeEnum_DermatologistMessage": string,
	"ServiceTypeEnum_DermatologistMessageReply": string,
	"ServiceTypeEnum_DermatologistVideo": string,
	"ServiceTypeEnum_Message": string,
	"ServiceTypeEnum_MessageReply": string,
	"ServiceTypeEnum_PhysiotherapistStartupVideo": string,
	"ServiceTypeEnum_PhysiotherapistMessage": string,
	"ServiceTypeEnum_PhysiotherapistMessageReply": string,
	"ServiceTypeEnum_Prescription": string,
	"ServiceTypeEnum_PsychologistVideo": string,
	"ServiceTypeEnum_PsychologistCrisisVideo": string,
	"ServiceTypeEnum_PsychologistFamilyTherapyVideo": string,
	"ServiceTypeEnum_RheumatologistVideo": string,
	"ServiceTypeEnum_SundVaegtStartupMessage": string,
	"ServiceTypeEnum_VideoConsultation": string,
	"ServiceTypeEnum_AllergyCheckVideo": string,
	"ServiceTypeEnum_DietitianStartupVideo": string,
	"UserTypeEnum_Admin": string,
	"UserTypeEnum_Doctor": string,
	"UserTypeEnum_Patient": string,
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": string,
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": string,
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": string,
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": string,
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": string,
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": string,
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": string,
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": string,
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": string,
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": string,
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": string,
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": string,
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": string,
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": string,
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": string,
	"ServiceTypeEnum_SundVaegtStartupMessageReply": string,
	"SubscriptionStatusEnum_Active": string,
	"SubscriptionStatusEnum_Canceled": string,
	"SubscriptionStatusEnum_Expired": string,
	"SubscriptionStatusEnum_PastDue": string,
	"SubscriptionStatusEnum_Trialing": string,
	"SubscriptionStatusEnum_Unknown": string,
	"ConsultationTypeEnum_DietitianCheckupVideo": string,
	"ServiceTypeEnum_DietitianCheckupVideo": string,
	"ConsultationTypeEnum_DietitianUploadAttachmentMessage": string,
	"ServiceTypeEnum_DietitianUploadAttachmentMessage": string,
	"ServiceTypeEnum_DietitianVideo": string,
	"AllergyCheckVideo": string,
	"ConsultationTypeEnum_AllergyCheck": string,
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": string,
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": string,
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": string,
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": string,
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": string,
	"ServiceTypeEnum_AcneProgrammeStartupMessage": string,
	"ServiceTypeEnum_AcneProgrammeStartupVideo": string,
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": string,
	"ConsultationTypeEnum_AcneDermatologistMessage": string,
	"ServiceTypeEnum_AcneDermatologistMessage": string,
	"ServiceTypeEnum_AcneDermatologistMessageReply": string,
	"ServiceTypeEnum_VeterinarianVideo": string,
	"ConsultationPaymentProviderEnum_Free": string,
	"ConsultationPaymentProviderEnum_CreatedByCaregiver": string,
	"ConsultationTypeEnum_VeterinarianVideo": string,
	"PetSex_Female": string,
	"PetSex_FemaleSterilized": string,
	"PetSex_Male": string,
	"PetSex_MaleNeutered": string,
	"PetSex_Unknown": string,
	"PetType_Dog": string,
	"PetType_Cat": string,
	"PetType_Rabbit": string,
	"PetType_Rodent": string,
	"ReferralOptionEnum_SpecialistsAndPrivateHospitals": string,
	"ReferralOptionEnum_Physiotherapy": string,
	"ReferralOptionEnum_Psychologist": string,
	"VetConsultationReasonEnum_Gastrointestinal": string,
	"VetConsultationReasonEnum_SkinCoatEars": string,
	"VetConsultationReasonEnum_Poisoning": string,
	"VetConsultationReasonEnum_Eyes": string,
	"VetConsultationReasonEnum_UrinaryTract": string,
	"VetConsultationReasonEnum_Lameness": string,
	"VetConsultationReasonEnum_RespiratoryTract": string,
	"VetConsultationReasonEnum_OralCavity": string,
	"VetConsultationReasonEnum_Pain": string,
	"VetConsultationReasonEnum_Claws": string,
	"VetConsultationReasonEnum_GenitalsMammaryGlands": string,
	"VetConsultationReasonEnum_ReproductionCycle": string,
	"VetConsultationReasonEnum_Behaviour": string,
	"VetConsultationReasonEnum_Prescription": string,
	"VetConsultationReasonEnum_OtherReason": string,
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": string,
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": string,
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": string,
	"PhysioConsultationOutcomeEnum_ConservativeApproachPatientContinuesAlone": string,
	"PhysioConsultationOutcomeEnum_OfferedFollowUpConsultation": string,
	"PhysioConsultationOutcomeEnum_ReturnedToVisitationForPhysicalTreatment": string,
	"PhysioConsultationOutcomeEnum_ReturnedToOwnDoctor": string,
	"PhysioConsultationOutcomeEnum_NoShow": string,
	"ConsultationTypeEnum_DynamicCodeVideo": string,
	"ServiceTypeEnum_DynamicCodeVideo": string,
	"ServiceTypeEnum_NurseVideo": string,
	"ServiceTypeEnum_MidwifeVideo": string,
	"ServiceTypeEnum_NurseMessage": string,
	"ServiceTypeEnum_NurseMessageReply": string,
	"ServiceTypeEnum_MidwifeMessage": string,
	"ServiceTypeEnum_MidwifeMessageReply": string,
	"ConsultationTypeEnum_VeterinarianMessage": string,
	"ServiceTypeEnum_VeterinarianMessage": string,
	"ServiceTypeEnum_VeterinarianMessageReply": string,
	"VetConsultationOutcomeEnum_RequestedMoreInformation": string,
	"ConsultationTypeEnum_PracticeManagerMessage": string,
	"CaregiverRoleEnum_PracticeManager_Indefinite": string,
	"ServiceTypeEnum_PracticeManagerMessage": string,
	"CaregiverRoleEnum_PracticeManager": string,
	"ConsultationTypeEnum_PsychologistMessage": string,
	"ServiceTypeEnum_PsychologistMessage": string,
	"SubscriptionStatusEnum_OnHold": string,
	"ReferralType_Physiotherapy": string,
	"ReferralType_Hospital": string,
	"ReferralType_Psychologist": string,
	"ReferralType_Specialist": string,
	"SpecialistVisitationOptionsEnum_InternMedicine": string,
	"SpecialistReferralCode_TreatmentAndInvestigation": string,
	"SpecialistReferralCode_Radiology": string,
	"SpecialistReferralCode_ContinuedTreatment": string,
	"SpecialistReferralCode_Visit": string,
	"SpecialistReferralCode_SingleConsultationAssessment": string,
	"HospitalCallPriority_Urgent": string,
	"HospitalCallPriority_Elective": string,
	"HospitalStatus_Outpatient": string,
	"HospitalStatus_Admission": string,
	"HospitalTransport_None": string,
	"HospitalTransport_Seated": string,
	"HospitalTransport_Lying": string,
	"PsychologyDiagnosis_RobberyViolenceOrRapeVictim": string,
	"PsychologyDiagnosis_TrafficOrAccidentVictim": string,
	"PsychologyDiagnosis_RelativesOfSeriouslyMentallyIllPersons": string,
	"PsychologyDiagnosis_PersonsAffectedBySeriousDisablingDisease": string,
	"PsychologyDiagnosis_RelativesOfPersonsAffectedBySeriousDisablingDisease": string,
	"PsychologyDiagnosis_RelativesInCaseOfDeath": string,
	"PsychologyDiagnosis_PersonsWhoHaveAttemptedSuicide": string,
	"PsychologyDiagnosis_WomenUndergoingAbortionAfter12WeeksOfPregnancy": string,
	"PsychologyDiagnosis_PersonsUnder18WhoHaveBeenVictimsOfIncestOrOtherSexualAbuse": string,
	"PsychologyDiagnosis_PersonsWithMildToModerateDepressionAfterPsychometricTest": string,
	"PsychologyDiagnosis_PersonsWithMildToModerateAnxietyIncludingMildToModerateOCD": string,
	"PsychologyDiagnosis_DeviationFrom6Months": string,
	"ServiceTypeEnum_NnStartupVideo": string,
	"ServiceTypeEnum_NnNurseCheckupVideo": string,
	"ServiceTypeEnum_NnDietitianCheckupVideo": string,
	"ServiceTypeEnum_NnDoctorMessage": string,
	"ServiceTypeEnum_NnDoctorMessageReply": string,
	"ServiceTypeEnum_NnScreeningQuestionnaireMessage": string,
	"ServiceTypeEnum_NnOnboardingQuestionnaireMessage": string,
	"ServiceTypeEnum_NnCheckupQuestionnaireMessage": string,
	"ServiceTypeEnum_NnExitQuestionnaireMessage": string,
	"ServiceTypeEnum_SundVaegtExitQuestionnaireMessage": string,
	"ConsultationTypeEnum_NnStartupVideo": string,
	"ConsultationTypeEnum_NnNurseCheckupVideo": string,
	"ConsultationTypeEnum_NnDietitianCheckupVideo": string,
	"ConsultationTypeEnum_NnDoctorMessage": string,
	"ConsultationTypeEnum_NnScreeningQuestionnaireMessage": string,
	"ConsultationTypeEnum_NnOnboardingQuestionnaireMessage": string,
	"ConsultationTypeEnum_NnCheckupQuestionnaireMessage": string,
	"ConsultationTypeEnum_NnExitQuestionnaireMessage": string,
	"ConsultationTypeEnum_SundVaegtExitQuestionnaireMessage": string,
	"ConsultationTypeEnum_SundVaegtFeedbackQuestionnaireMessage": string,
	"ServiceTypeEnum_SundVaegtFeedbackQuestionnaireMessage": string,
	"HospitalPriorityOptionsEnum_Urgent": string,
	"HospitalPriorityOptionsEnum_Elective": string,
	"HospitalTransportOptionsEnum_None": string,
	"HospitalTransportOptionsEnum_Seated": string,
	"HospitalTransportOptionsEnum_Lying": string,
	"HospitalStatusOptionsEnum_Admission": string,
	"HospitalStatusOptionsEnum_Outpatient": string,
	"ConsultationPaymentProviderEnum_HouseholdAccess": string,
	"ServiceTypeEnum_MenopauseStartupVideo": string,
	"ServiceTypeEnum_MenopauseNurseCheckupVideo": string,
	"ServiceTypeEnum_MenopauseNurseMessage": string,
	"ServiceTypeEnum_MenopauseNurseMessageReply": string,
	"ConsultationTypeEnum_MenopauseStartupVideo": string,
	"ConsultationTypeEnum_MenopauseNurseCheckupVideo": string,
	"ConsultationTypeEnum_MenopauseNurseMessage": string,
	"ConsultationTypeEnum_MenopauseOffboardingVideo": string,
	"ServiceTypeEnum_MenopauseOffboardingVideo": string,
	"CaregiverRoleEnum_Gynecologist": string,
	"CaregiverRoleEnum_MenopauseDoctor": string,
	"CaregiverSpecialization_Menopause": string,
	"CaregiverRoleEnum_Gynecologist_Indefinite": string,
	"CaregiverRoleEnum_MenopauseDoctor_Indefinite": string,
	"ConsultationTypeEnum_DietitianMessage": string,
	"ServiceTypeEnum_DietitianMessage": string,
	"ServiceTypeEnum_DietitianMessageReply": string,
	"EpicrisisDocumentType_DischargeLetter": string,
	"EpicrisisDocumentType_OutPatientDischargeLetter": string,
	"EpicrisisDocumentType_CasualtyWardLetter": string,
	"EpicrisisDocumentType_RadiologyReport": string,
	"EpicrisisDocumentType_PrivateSpecialistLetter": string,
	"ConsultationTypeEnum_MenopauseDietitianVideo": string,
	"ServiceTypeEnum_MenopauseDietitianVideo": string,
	"ServiceTypeEnum_MenopauseHalfwayVideo": string,
	"ConsultationTypeEnum_MenopauseHalfwayVideo": string,
	"AuditProblemCategory_IncorrectDiagnosis": string,
	"AuditProblemCategory_InsufficientTreatment": string,
	"AuditProblemCategory_MedicationError": string,
	"AuditProblemCategory_DocumentationError": string,
	"AuditProblemCategory_CommunicationIssue": string,
	"AuditProblemCategory_OtherIssue": string,
	"PhysioConsultationOutcomeEnum_OfferedVideoConsultation": string,
	"PhysioConsultationOutcomeEnum_NeedMoreInformation": string,
	"CaregiverRoleEnum_Doctor_Plural": string,
	"CaregiverRoleEnum_Nurse_Plural": string,
	"CaregiverRoleEnum_Dentist_Plural": string,
	"CaregiverRoleEnum_Midwife_Plural": string,
	"CaregiverRoleEnum_Dermatologist_Plural": string,
	"CaregiverRoleEnum_Rheumatologist_Plural": string,
	"CaregiverRoleEnum_Physiotherapist_Plural": string,
	"CaregiverRoleEnum_Psychologist_Plural": string,
	"CaregiverRoleEnum_AllergyDoctor_Plural": string,
	"CaregiverRoleEnum_SundVaegtDoctor_Plural": string,
	"CaregiverRoleEnum_SundVaegtNurse_Plural": string,
	"CaregiverRoleEnum_Dietitian_Plural": string,
	"CaregiverRoleEnum_AcneDermatologist_Plural": string,
	"CaregiverRoleEnum_Veterinarian_Plural": string,
	"CaregiverRoleEnum_PracticeManager_Plural": string,
	"CaregiverRoleEnum_Gynecologist_Plural": string,
	"CaregiverRoleEnum_MenopauseDoctor_Plural": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "nb" || (!process.env.enforcedLocale && getLocale("da") === "nb")) {
			return _nb[name] ?? name
		}

		return name
	},
}) as Translations

export { R }